import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import ax from "../config"
import { openNotification } from "../../components/helpers/notification"
import { message } from "antd"
import { bookingAction } from "./Administrator/BookingSlice"

const initialState = {
  ratings: null,
  accuralPointsRules: null,
  typesForPointsRulesAction: null,
  racesInfo: null,
  racesParticipantsInfo: null,
  currentSubscribe: null,
  isLoading: false,
  racePatisipantsList: null,
}

export const getUserRating = createAsyncThunk(
  "usersRating/getUserRating",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ax.get("/api/admin/points/userPointsRating")
      return data
    } catch (error) {
      return rejectWithValue(
        `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      )
    }
  },
)

export const getPointsRulesActions = createAsyncThunk(
  "usersRating/getPointsRulesActions",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ax.get("api/admin/points/mobileActionPointsRules")
      return data
    } catch (error) {
      return rejectWithValue(
        `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      )
    }
  },
)

export const addRace = createAsyncThunk(
  "usersRating/addRace",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await ax.put(
        "api/admin/points/tmplRaces",
        payload,
      )
      return data
    } catch (error) {
      return rejectWithValue(
        `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      )
    }
  },
)

export const editRace = createAsyncThunk(
  "usersRating/editRace",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await ax.post(
        "api/admin/points/tmplRaces",
        payload,
      )
      return data
    } catch (error) {
      return rejectWithValue(
        `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      )
    }
  },
)

export const deleteRace = createAsyncThunk(
  "usersRating/deleteRace",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await ax.delete(
        `api/admin/points/tmplRaces?id=${payload}`
      )
      return data
    } catch (error) {
      return rejectWithValue(
        `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      )
    }
  },
)

export const addPointsRulesActions = createAsyncThunk(
  "usersRating/addPointsRulesActions",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await ax.put(
        "api/admin/points/mobileActionPointsRules",
        payload,
      )
      return data
    } catch (error) {
      return rejectWithValue(
        `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      )
    }
  },
)

export const editPointsRulesActions = createAsyncThunk(
  "usersRating/editPointsRulesActions",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await ax.post(
        "api/admin/points/mobileActionPointsRules",
        payload,
      )
      return data
    } catch (error) {
      return rejectWithValue(
        `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      )
    }
  },
)

export const deletePointsRulesActions = createAsyncThunk(
  "usersRating/deletePointsRulesActions",
  async (payload, { rejectWithValue }) => {
    try {
      console.log("delete payload", payload)
      const { data } = await ax.delete(
        `api/admin/points/mobileActionPointsRules?id=${payload}`,
      )
      return data
    } catch (error) {
      return rejectWithValue(
        `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      )
    }
  },
)

export const getTypesForPointsRulesAction = createAsyncThunk(
  "usersRating/getTypesForPointsRulesAction",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ax.get("api/admin/mobileActionTypesForPointsRules")
      return data
    } catch (error) {
      return rejectWithValue(
        `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      )
    }
  },
)

export const getRaces = createAsyncThunk(
  "usersRating/getRaces",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ax.get("api/admin/points/tmplRaces")
      return data
    } catch (error) {
      return rejectWithValue(
        `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      )
    }
  },
)

export const getRacesParticipants = createAsyncThunk(
  "usersRating/getRacesParticipants",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await ax.get(
        `api/admin/points/raceParticipants?raceId=${payload}`,
      )
      return data
    } catch (error) {
      return rejectWithValue(
        `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      )
    }
  },
)

export const setRaceResult = createAsyncThunk(
  "userRating/setRaceResult",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await ax.post("api/admin/points/setRaceWinners", payload)
      return data
    } catch (error) {
      return rejectWithValue(
        `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      )
    }
  },
)

export const getRaceParticipants = createAsyncThunk(
  "userRating/getRaceParticipants",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await ax.get(
        `api/admin/points/raceParticipants?raceId=${payload}`,
      )
      return data
    } catch (error) {
      return rejectWithValue(
        `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      )
    }
  },
)

const UsersRatingSlice = createSlice({
  name: "UsersRating",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserRating.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getUserRating.fulfilled, (state, action) => {
      state.isLoading = false
      state.ratings = action.payload
    })
    builder.addCase(getUserRating.rejected, (state, action) => {
      state.isLoading = false
      openNotification({
        type: "error",
        message: action.payload,
      })
    })

    builder.addCase(getPointsRulesActions.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getPointsRulesActions.fulfilled, (state, action) => {
      state.isLoading = false
      state.accuralPointsRules = action.payload
    })
    builder.addCase(getPointsRulesActions.rejected, (state, action) => {
      state.isLoading = false
      openNotification({
        type: "error",
        message: action.payload,
      })
    })

    builder.addCase(addPointsRulesActions.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(addPointsRulesActions.fulfilled, (state, action) => {
      state.isLoading = false
      state.accuralPointsRules = action.payload
    })
    builder.addCase(addPointsRulesActions.rejected, (state, action) => {
      state.isLoading = false
      openNotification({
        type: "error",
        message: action.payload,
      })
    })

    builder.addCase(editPointsRulesActions.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(editPointsRulesActions.fulfilled, (state, action) => {
      state.isLoading = false
      state.accuralPointsRules = action.payload
      openNotification({
        type: "success",
        message: "Правила успешно изменены",
      })
    })
    builder.addCase(editPointsRulesActions.rejected, (state, action) => {
      state.isLoading = false
      openNotification({
        type: "error",
        message: action.payload,
      })
    })
    builder.addCase(deletePointsRulesActions.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(deletePointsRulesActions.fulfilled, (state, action) => {
      state.isLoading = false
      state.accuralPointsRules = action.payload
    })
    builder.addCase(deletePointsRulesActions.rejected, (state, action) => {
      state.isLoading = false
      openNotification({
        type: "error",
        message: action.payload,
      })
    })
    builder.addCase(getTypesForPointsRulesAction.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getTypesForPointsRulesAction.fulfilled, (state, action) => {
      state.isLoading = false
      state.typesForPointsRulesAction = action.payload
    })
    builder.addCase(getTypesForPointsRulesAction.rejected, (state, action) => {
      state.isLoading = false
      openNotification({
        type: "error",
        message: action.payload,
      })
    })
    builder.addCase(getRaces.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getRaces.fulfilled, (state, action) => {
      state.isLoading = false
      state.racesInfo = action.payload
    })
    builder.addCase(getRaces.rejected, (state, action) => {
      ;((state.isLoading = false),
        openNotification({
          type: "error",
          message: action.payload,
        }))
    })
    builder.addCase(getRacesParticipants.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getRacesParticipants.fulfilled, (state, action) => {
      state.isLoading = false
      state.racesParticipantsInfo = action.payload
    })
    builder.addCase(getRacesParticipants.rejected, (state, action) => {
      ;((state.isLoading = false),
        openNotification({
          type: "error",
          message: action.payload,
        }))
    })
    builder.addCase(setRaceResult.pending, (state) => {
      state.isLoading = false
    })
    builder.addCase(setRaceResult.fulfilled, (state, action) => {
      state.isLoading = false
    })
    builder.addCase(setRaceResult.rejected, (state, action) => {
      state.isLoading = false
      openNotification({
        type: "error",
        message: action.payload,
      })
    })
    builder.addCase(getRaceParticipants.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getRaceParticipants.fulfilled, (state, action) => {
      state.isLoading = false
      state.racePatisipantsList = action.payload
    })
    builder.addCase(getRaceParticipants.rejected, (state, action) => {
      state.isLoading = false
      openNotification({
        type: "error",
        message: action.payload,
      })
    })
    builder.addCase(addRace.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(addRace.fulfilled, (state, action) => {
      ;((state.isLoading = false), (state.racesInfo = action.payload))
    })
    builder.addCase(addRace.rejected, (state) => {
      state.isLoading = false
      openNotification({
        type: "error",
        message: action.payload,
      })
    })
    builder.addCase(editRace.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(editRace.fulfilled, (state, action) => {
      ;((state.isLoading = false), (state.racesInfo = action.payload))
    })
    builder.addCase(editRace.rejected, (state) => {
      state.isLoading = false
      openNotification({
        type: "error",
        message: action.payload,
      })
    })
    builder.addCase(deleteRace.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(deleteRace.fulfilled, (state, action) => {
      ;((state.isLoading = false), (state.racesInfo = action.payload))
    })
    builder.addCase(deleteRace.rejected, (state) => {
      state.isLoading = false
      openNotification({
        type: "error",
        message: action.payload,
      })
    })
  },
})

export const {} = UsersRatingSlice.actions
export default UsersRatingSlice.reducer
